import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseClientEquipmentLastDeclarationsPerCategory<T> = {
  equipmentId?: string;
  filters?: {
    search?: string;
    page?: number;
  }
  mapper?: (data: any) => T
}

export const useClientEquipmentLastUsageDeclarationsPerCategory = <T,>({
  equipmentId,
  filters: { search = '', page = 1 } = {},
  mapper = Mapper.default<T>(),
}: UseClientEquipmentLastDeclarationsPerCategory<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['clientEquipmentLastUsageDeclarationsPerCategory', equipmentId, search, page],
    queryFn: () => {
      return privateAxios.get(`/client/equipments/${equipmentId}/last_usage_declarations_per_category`, {
        params: {
          search,
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest }
}
